// extracted by mini-css-extract-plugin
export var container = "_kg-0";
export var dotAnimation = "_kg-2";
export var dotsLoading = "_kg-1";